module.exports = function () {
    $(document).ready(function (event) {

        $(document).on('click', '.btn-add', function(e)
        {
            e.preventDefault();

            var fieldName = $('#new_field_input').val();
            var fieldNameSmall = fieldName.toLowerCase();

            if (fieldName != '') {

                var newFieldGroup = '<div class="row"><input name="reading_fields_names[]" type="hidden" value="'+fieldNameSmall+'" /><div class="col-sm-1 pull-left"><button class="btn btn-remove" type="button" style="border:none;background:transparent;color:red;font-weight: bold;">Delete</button></div><div class="col-sm-5"><div class="form-group "><label for="reading_'+fieldNameSmall+'" class="control-label col-sm-6 label-required" style="text-transform: capitalize;">Reading '+fieldName+'</label><div class="col-sm-6"><input class="form-control" required="required" name="reading_fields[]" type="text" id="reading_'+fieldNameSmall+'"></div></div></div><div class="col-sm-6"><div class="form-group "><label for="reading_'+fieldNameSmall+'_serial" class="control-label col-sm-6 label-required" style="text-transform: capitalize;">Reading '+fieldName+' Serial</label><div class="col-sm-6"><input class="form-control" required="required" name="reading_fields_serials[]" type="text" id="reading_'+fieldNameSmall+'_serial"></div></div></div></div>';
                var controlForm = $('.controls');

                $(newFieldGroup).appendTo(controlForm);

                $('#new_field_input').val('');
            }

        }).on('click', '.btn-remove', function(e)
        {
            $(this).parents('.row:first').remove();

            e.preventDefault();
            return false;
        });

    });
}();